import React, { useEffect, useState } from "react";
import { ValidateResponse, getCurrentPage, setCurrentPage } from "../../helpers/global";
import { fetchProductRepairs } from "../../helpers/articles";
import { List } from "../../../components/List";
import { ListPagination } from "../../../components/List/Pagination";
import { Message } from "../../../components/Message";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppArticlesRepairsOverview({ current, setFilterFields, filterValues, identifier }) {

    let pageSize = 10; // default values ergens globaal opslaan?

    const [repairs, setRepairs] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState();
    const [pageNr, setPageNr] = useState(getCurrentPage(current));
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)));
    const [filterString, setFilterString] = useState("{}");

    if (JSON.stringify(filterValues) !== filterString) {
        setFilterString(JSON.stringify(filterValues));
        setIsLoaded(false);
        setFilters(filterValues);
        setCurrentPage(1, current, setPageNr);
    }

    if (pageNr !== getCurrentPage(current)) {
        setPageNr(getCurrentPage(current));
    }

    const handlePagination = (page) => {
        setCurrentPage(page, current, setPageNr);
    }

    let listColumns = [
        { key: "repairNumber", label: "Reparatienummer", type: "text" },
        { key: "serialNumber", label: "Serienummer", type: "text" },
        { key: "statusLabel", label: "Status", type: "text" },
        { key: "createDate", label: "Aanmaakdatum", type: "date" },
        { key: "repairDate", label: "Reparatiedatum", type: "date" },
        { key: "repairer", label: "Reparateur", type: "text" },
        { key: "repairNumber", label: "Reparatiebon", type: "download", display: "icon", fileName: "documentName", documentType: "repair" },
        { key: "repairId", type: "link", path: "details/:repairId", id: "repairId", hideView: "small" },
    ];


    // planned date or inspect date. let op! op key, dus checke als er kolom bij of af gaat!
    if (current === 'open') {
        delete (listColumns[4]);
        delete (listColumns[5]);
        delete (listColumns[6]);
    }

    // Afgevoerd zie je niet... wel afgerond
    const optionsConclusion = [
        { value: "PROCESSING", label: "In behandeling" }, // new/processing/waiting
        { value: "FIXED", label: "Afgerond" }, // new/processing/waiting
    ]

    // // The filters are set here and send to parent onloaded
    let filterFields = {
        'repairId': { type: 'text', label: "Repartienummer" },
        'conclusion': { type: 'select', label: "Reparatiestatus", options: optionsConclusion },
    }

    if (isLoaded === true && loadFilters !== current) {
        setLoadFilters(current);
    }

    useEffect(() => {

        async function fetchData() {

            const callData = {
                context: "overview-" + current,
                filters: {
                    limitOffset: pageSize * pageNr - (pageSize - 1),
                    limitRows: pageSize,
                    ...filters
                }
            }

            await fetchProductRepairs(callData).then((res) => {

                const response = ValidateResponse(res.data, 'repairs');
                if (response.status === 'success') {

                    if (response.totalCount !== undefined) {
                        setTotalCount(response.totalCount);
                    }
                    setRepairs(response.repairs);
                    setFilterFields(filterFields);
                    setIsLoaded(true);

                }
                else {
                    setError(response.message);
                }
            }).catch((error) => {
                const response = ValidateResponse(error);
                setError(response.message);
            });
        }

        fetchData();
    }, [current, pageNr, filterString, filters, pageSize]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (repairs === undefined || repairs === null || Object.keys(repairs).length === 0) {
        return (<Message type="noData" />);
    }



    return (
        <>
            <List
                columns={listColumns}
                data={repairs}
                identifier={identifier}
            />

            <div className={'spacer'}></div>

            <ListPagination
                currentPage={pageNr}
                setCurrentPage={handlePagination}
                totalCount={totalCount}
                pageSize={pageSize}
            />
            <div style={{ height: '30px' }}></div>
        </>
    );
}